; (function () {
  'use strict';

  const angular = window.angular;

  CustomerFormController.$inject = ['$scope', 'Admin', 'Var', 'AppUtils', 'LocalStorageService', 'LANGS'];

  angular
    .module('app')
    .component('customerForm', {
      template:'<form name="$ctrl.customerForm" class="validate" novalidate ng-show="!$ctrl.saving"><div class="modal-header"><button type="button" class="close" ng-click="$ctrl.modalInstance.dismiss()"><i class="fas fa-times"></i></button> <span translate>{{::($ctrl.customer.id? \'buttons.edit\': \'buttons.create\')}}</span> <span translate>entities.organization.customer.modelName</span></div><div class="modal-body paddingB0"><div class="form-group" show-errors><label class="control-label" for="name-input" translate>entities._all.name</label> <input id="name-input" name="nameInput" ng-model="$ctrl.customer.name" translate-attr="::{placeholder: \'entities._all.name\'}" class="form-control" required><p class="help-block" ng-messages="$ctrl.customerForm.nameInput.$error"><span ng-message="required">You did not enter a field</span></p></div><div class="form-group" show-errors><label class="control-label" for="businessName-input" translate>entities._all.businessName</label> <input id="businessName-input" name="businessNameInput" ng-model="$ctrl.customer.businessName" translate-attr="::{placeholder: \'entities._all.businessName\'}" class="form-control input-sm" required><p class="help-block" ng-messages="$ctrl.updateForm.businessNameInput.$error"><span ng-message="required">You did not enter a field</span></p></div><div class="form-group"><label class="control-label" for="address-input" translate>entities._all.address</label> <input id="address-input" name="address-input" translate-attr="::{placeholder: \'entities._all.address\'}" ng-model="$ctrl.customer.address" class="form-control input-sm"></div><div class="form-group"><label class="control-label" translate>entities._all.country</label><div class="select2-sm"><ui-select ng-model="$ctrl.customer.countryId" theme="select2"><ui-select-match placeholder="{{\'general._select.a\' | translate}} {{\'entities._all.country\' | translate}}">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="country.id as country in $ctrl.countries | filter: {name: $select.search}"><div ng-bind-html="country.name | highlight: $select.search"></div></ui-select-choices></ui-select></div><p class="help-block"></p></div><div class="form-group"><label class="control-label" translate>entities._all.timezone</label><div class="select2-sm"><ui-select ng-model="$ctrl.customer.timeZoneId" theme="select2"><ui-select-match placeholder="{{\'general._select.a\' | translate}} {{\'entities._all.timezone\' | translate}}">{{$select.selected.text}}</ui-select-match><ui-select-choices repeat="timezone.id as timezone in $ctrl.timeZones | filter: {text: $select.search}"><div ng-bind-html="timezone.text | highlight: $select.search"></div></ui-select-choices></ui-select></div><p class="help-block"></p></div><div class="form-group"><label class="control-label" translate>entities._all.language</label><select class="form-control input-sm" ng-model="$ctrl.customer.language"><option ng-repeat="lang in $ctrl.langs" value="{{lang}}">{{\'entities.organization.customer.languages.\' + lang | translate}}</option></select></div><div class="form-group"><label class="control-label" for="description-input" translate>entities._all.description</label> <textarea id="description-input" name="description-input" ng-model="$ctrl.customer.description" class="form-control input-sm"></textarea></div></div><div class="alert alert-warning no-margin text-center" ng-show="$ctrl.saveError">{{$ctrl.saveError}}</div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" ng-click="$ctrl.modalInstance.dismiss()" translate>buttons.cancel</button> <button class="btn btn-primary" ng-if="$ctrl.customer.id" ng-click="$ctrl.saveCustomer()" translate>buttons.update</button> <button class="btn btn-primary" ng-if="!$ctrl.customer.id" ng-click="$ctrl.saveCustomer()" translate>buttons.create</button></div></form><div style="position: relative; height: 210px" ng-show="$ctrl.saving"><spinner css-class="\'small\'" show="$ctrl.saving"></spinner></div>',
      controller: CustomerFormController,
      bindings: {
        modalInstance: '<',
        resolve: '<',
      },
    });

  function CustomerFormController($scope, Admin, Var, utils, LocalStorageService, LANGS) {
    let vm = this;

    vm.$onInit = function () {
      vm.customer = angular.copy(vm.resolve.customer || {});
      vm.timeZones = vm.resolve.timeZones;
      vm.countries = vm.resolve.countries;
      vm.langs = LANGS;
      vm.saveCustomer = saveCustomer;

      if (!vm.customer.id) {
        if (!vm.customer.countryId) {
          const defaultCountry = vm.countries.find(c => c.iso === 'CL');
          vm.customer.countryId = defaultCountry ? defaultCountry.id : null;
        }

        if (!vm.customer.timeZoneId) {
          const defaultTimeZone = vm.timeZones.find(c => c.utc && c.utc.indexOf('America/Santiago') !== -1);
          vm.customer.timeZoneId = defaultTimeZone ? defaultTimeZone.id : null;
        }

        if (!vm.customer.language) {
          vm.customer.language = 'en';
        }
      }
    };

    function saveCustomer() {
      if (!vm.customerForm.$valid) {
        $scope.$broadcast('show-errors-check-validity');
        return;
      }

      // vm.resolve.varId is passed explicitly when this form is opened while
      // browsing a specific Var; when editing, the customer itself already
      // has its own varId. Neither is available from Admin.getCachedCurrent()
      // for a SuperAdmin/SupportAdmin session (they have no varId of their own).
      const varId = vm.resolve.varId || vm.customer.varId || Admin.getCachedCurrent().varId;

      vm.saving = true;
      if (vm.customer.id) {
        Var.customers
          .updateById({
            id: varId,
            fk: vm.customer.id,
          }, {
            name: vm.customer.name,
            businessName: vm.customer.businessName,
            address: vm.customer.address,
            description: vm.customer.description,
            timeZoneId: vm.customer.timeZoneId,
            countryId: vm.customer.countryId,
            language: vm.customer.language,
          })
          .$promise
          .then(response => {
            LocalStorageService.clear();
            vm.saving = false;
            vm.modalInstance.close(response);
          })
          .catch(err => {
            console.log(err);
            vm.saveError = utils.getHTTPError(err);
            vm.saving = false;
          });
      } else {
        Var.customers
          .create({
            id: varId,
          }, {
            name: vm.customer.name,
            businessName: vm.customer.businessName,
            address: vm.customer.address,
            description: vm.customer.description,
            language: vm.customer.language,
          })
          .$promise
          .then(response => {
            LocalStorageService.clear();
            vm.saving = false;
            vm.modalInstance.close(response);
          })
          .catch(err => {
            console.log(err);
            vm.saveError = utils.getHTTPError(err);
            vm.saving = false;
          });
      }
    }
  }

})();
